
import { defineAsyncComponent } from 'vue'

export default {
  data() {
    return {
      voiceConfig: {
        isOn: true, // 语音播报开关
        rate: 0,
        voiceType: 'Microsoft Xiaoxiao',
      },
      isSynthesizing: false, // 是否合成中
      toChangeText: '',
      returnText: '',
      audioChunks: null,
      ws: null,
      isConnected: false,
      isVoiceing: false, // 是否播放中
    }
  },
  components: {
    aiChatBtn: defineAsyncComponent(() => import('./aiChatBtn'))
  },
  methods: {
    initConnect() {
      const serverUrl = 'wss://user.topeti.com/api/tts/stream';
      this.ws = new WebSocket(serverUrl);

      this.ws.onopen = () => {
        this.isConnected = true;
      };

      this.ws.onmessage = (event) => {
        if (typeof event.data === 'string') {
          if(event.data.startsWith('{')){
            let fd = JSON.parse(event.data);
            if(fd.type === 'end'){
              setTimeout(() => {
                this.handleMessage(event.data);
              }, 100);
            }else{
              this.handleMessage(event.data);
            }
          }
        } else {
          if (event.data instanceof Blob) {
            event.data.arrayBuffer().then(d => {
              this.handleAudioChunk(d);
            });
          } else {
            this.handleAudioChunk(event.data);
          }
        }
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket错误:', error);
      };

      this.ws.onclose = () => {
        this.isConnected = false;
      };
    },
    toSaveText (text) {
      this.returnText += text
      setTimeout(() => {
        if (this.voiceConfig.isOn && !this.isSynthesizing) {
          this.audioChunks = []
          this.startStreaming()
        }
      }, 1000)
    },
    splitAtLastTerminator() {
      const text = this.returnText.replace(/<[^>]*>/g, '')
                  .replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s，。！？；："'""（）【】《》、]/g, '')
                  .replace(/\s+/g, ' ')
                  .trim();
      if (!text || typeof text !== 'string') {
        return { before: '', after: '', terminator: '' };
      }

      // 定义终止符号（逗号、句号、感叹号、问号、分号）
      const terminators = ['，', '。', '！', '？', '；', ',', '.', '!', '?', ';'];

      let lastIndex = -1;
      let foundTerminator = '';

      // 查找最后一个终止符号的位置
      terminators.forEach(term => {
        const index = text.lastIndexOf(term);
        if (index > lastIndex) {
          lastIndex = index;
          foundTerminator = term;
        }
      });

      // 如果没有找到终止符号
      if (lastIndex === -1) {
        return {
          before: text,
          after: '',
          terminator: '',
          position: -1
        };
      }

      // 分割文本（包含终止符号本身）
      const beforeText = text.substring(0, lastIndex + 1);
      const afterText = text.substring(lastIndex + 1).trim();
      return {
        before: beforeText,
        after: afterText,
        terminator: foundTerminator,
        position: lastIndex
      };
    },
    startStreaming() {
      if (!this.returnText || !this.voiceConfig.isOn) {
        this.isSynthesizing = false
        return false
      }
      this.isSynthesizing = true
      const { before, after } = this.splitAtLastTerminator()
      this.toChangeText = before
      this.returnText = after
      const rate = parseInt(this.voiceConfig.rate)
      if (this.toChangeText) {
        const request = {
          text: this.toChangeText,
          voice: this.voiceConfig.voiceType,
          rate: rate,
          volume: 100
        };
        this.ws.send(JSON.stringify(request));
      }
    },

    playAudio() {
      if (this.audioChunks.length === 0 && !this.voiceConfig.isOn) return;

      try {
        // 合并所有音频块
        const totalLength = this.audioChunks.reduce((sum, chunk) => sum + chunk.byteLength, 0);
        const audioData = new Uint8Array(totalLength);
        const that = this
        let offset = 0;
        this.audioChunks.forEach(chunk => {
          audioData.set(new Uint8Array(chunk), offset);
          offset += chunk.byteLength;
        });

        // 创建Blob并播放
        const blob = new Blob([audioData], { type: 'audio/mp3' });
        const url = URL.createObjectURL(blob);

        const audio = document.getElementById('audioPlayer');
        audio.src = url;

        audio.onended = () => {
          URL.revokeObjectURL(url);
          that.isVoiceing = false
          if (that.audioChunks.length > 0) {
            that.playAudio()
          }
        };

        if (this.voiceConfig.isOn) {
          audio.play().catch(() => {
            that.isVoiceing = false
          });
          this.isVoiceing = true
          this.audioChunks = []
        } else {
          this.stopPlay()
        }
      } catch (error) {
        console.log(error)
      }
    },

    stopPlay () {
      const audioPlayer = document.getElementById('audioPlayer');
      if (audioPlayer) {
        audioPlayer.pause()
        this.isSynthesizing = false
        this.isVoiceing = false
        this.toChangeText = ''
        this.returnText = ''
        this.audioChunks = []
      }
    },

    handleMessage(data) {
      try {
        const message = JSON.parse(data);
        switch (message.type) {
          case 'end':
            this.startStreaming()
            if (!this.isVoiceing) {
              this.playAudio();
            }
            break;
          default:
        }
      } catch (e) {
        console.log('收到文本消息:', data);
      }
    },
    handleAudioChunk(chunk) {
      if (!chunk) return;
      this.audioChunks.push(chunk);
    },
  },
  mounted () {
    this.initConnect()
  },

}
